var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConnected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.053,
    height: 10.774,
    viewBox: "0 0 16.053 10.774",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 16.053,
    height: 10.774,
    transform: "translate(0 0)",
    fill: "#4e4e4e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2257",
    "data-name": "Group 2257",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    "data-name": "Group 2223",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M48.894.024A5.384,5.384,0,0,0,43.816,8.24a2.939,2.939,0,0,0,1.3-.708,3.912,3.912,0,0,1,3.006-6.049c.087-.006.175-.01.264-.01a3.913,3.913,0,1,1,0,7.827c-.089,0-.177,0-.264-.01a6.412,6.412,0,0,1-1.3,1.252A5.387,5.387,0,1,0,48.894.024",
    transform: "translate(-37.716 0)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M9.953,8.24a5.37,5.37,0,0,0,0-5.706,2.937,2.937,0,0,0-1.3.708A3.913,3.913,0,0,1,5.652,9.291c-.087.006-.175.01-.264.01a3.913,3.913,0,0,1,0-7.827c.089,0,.177,0,.264.01A6.409,6.409,0,0,1,6.95.232a5.388,5.388,0,1,0,3,8.008",
    transform: "translate(-0.001 0)",
    fill: "#4e4e4e"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/connected.0a224560b8a5273677186491738f4bb8.svg";